import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=ec472474&scoped=true&"
import script from "./LoadingIndicator.vue?vue&type=script&lang=js&"
export * from "./LoadingIndicator.vue?vue&type=script&lang=js&"
import style0 from "./LoadingIndicator.vue?vue&type=style&index=0&id=ec472474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec472474",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec472474')) {
      api.createRecord('ec472474', component.options)
    } else {
      api.reload('ec472474', component.options)
    }
    module.hot.accept("./LoadingIndicator.vue?vue&type=template&id=ec472474&scoped=true&", function () {
      api.rerender('ec472474', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/layout/LoadingIndicator.vue"
export default component.exports